import React from 'react';
import { Router } from 'react-router-dom';
import { observer, Provider } from 'mobx-react';
import Rotes from './routes';
import ErrorBoundary from './Components/ErrorBoundary';
import { history, navigationStore } from '@app/Stores/NavigationStore';
import { NotificationContainer } from './Components/ToastNotification';
import { ToolTipContainer } from './Components/ToolTipItem';

type AppProps = {
    callback: () => void;
};

@observer
export default class App extends React.Component<AppProps, {}> {

	componentDidMount() {
		this.props.callback();
		navigationStore.init();
    }

	render() {
		return (
			<ErrorBoundary>
				<Provider>
					{/*<React.StrictMode>*/}
					<Router history={history}>{Rotes.routs}</Router>
					{/*</React.StrictMode>*/}
				</Provider>
				<NotificationContainer />
				<ToolTipContainer />
			</ErrorBoundary>
		);
	}
}